export default __webpack_public_path__ + "static/media/freeTag.318c9554.svg";